import Image from 'next/image'
import { globalIntegrationsMetadata } from '@omnea-app/config/globalIntegrations'
import { useCustomLogo } from '@omnea-app/fe-settings/integrations/useCustomLogo'
import { CustomIntegration } from '@omnea-app/fe-settings/integrations/useListExtOpsIntegrations'

interface Props {
  customIntegration: CustomIntegration
}

export const CustomHttpIntegrationIcon = ({ customIntegration }: Props) => {
  const { signedUrl } = useCustomLogo({ filestoreId: customIntegration.logo })
  const logoSrc = signedUrl || globalIntegrationsMetadata.http.logo

  return <Image src={logoSrc} alt={customIntegration.name} width={16} height={16} />
}
